import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGroupGetAll } from '../../services';

export const fetchSliderGroupGetAll = createAsyncThunk(
    'sliderGroupGetAll/fetchSliderGroupGetAll',
    async () => {
        const response = await SliderGroupGetAll()
        return response.result
    }
);

const sliderGroupGetAllSlice = createSlice({
    name: 'sliderGroupGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroupGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGroupGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGroupGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGroupGetAllSlice.reducer;
